// extracted by mini-css-extract-plugin
export default {"wrapper":"V2QX","disabled":"dDRp","dot":"V2t1","radio":"KmK2","label":"PtLv"};